/** @format */

import {Modal, ModalFooter, ModalHeader, Toast} from '@sttark/design-system';
import {useSave} from 'frontier/components/form/use_save';
import {Button} from '@sttark/design-system';
import React, {useState} from 'react';

export const ContinueOrderFromQuote = props => {
    const {order} = props;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isToastOpen, setIsToastOpen] = useState(false);

    const {save, isSaving, error} = useSave('/carts/add-saved');

    // allows the user to notinue editing quote in cart
    const handleContinueQuote = async () => {
        const response = await save({orderId: order.id});

        if (response.body.success) {
            window.location = '/orders/quoter/' + order.id;
        }

        setIsModalOpen(false);
    };
    return (
        <>
            <Toast
                onClose={() => setIsToastOpen(false)}
                autoHideDuration={4000}
                isOpen={isToastOpen}
                zIndex={3001}
                autoHide>
                <p className="m-0 p-0 color-structure-white">Added to cart successfully!</p>
            </Toast>
            <Modal onClose={() => setIsModalOpen(false)} isOpen={isModalOpen} bodyHeightAuto>
                <ModalHeader onClose={() => setIsModalOpen(false)}>Edit Quote</ModalHeader>
                <div>
                    <h4 className="mx-0 mb-2 mt-0" style={{fontSize: 18}}>
                        Do you wish to proceed?
                    </h4>
                    <p className="m-0">
                        You are about to edit this Quote. Your Saved Quote <strong>will not</strong>{' '}
                        be removed from the list of Saved Quotes.
                    </p>
                </div>
                <ModalFooter>
                    <div className="d-flex align-items-center justify-content-end gap-4">
                        <Button
                            onClick={() => setIsModalOpen(false)}
                            label="Cancel"
                            secondary
                            small
                        />
                        <Button
                            primary
                            small
                            onClick={handleContinueQuote}
                            disabled={isSaving}
                            label={isSaving ? 'Taking you there...' : 'Edit in Quoter'}
                        />
                    </div>
                </ModalFooter>
            </Modal>
            <button
                className="p-0 mx-0 mt-0 mb-2 color-accent-primary d-flex align-items-center justify-content-center gap-2"
                onClick={() => setIsModalOpen(true)}>
                <i className="fas fa-gear" />
                <u>Continue Quote</u>
            </button>
        </>
    );
};
